const PENDING = 'pending';
const REJECTED = 'rejected';

const COLORS = {
    pending: '#f5a623',
    rejected: '#ff0000a6',
    verified: '#008000b8',
};

const REASON_LABELS = {
    blank: 'Parece vazio',
    placeholder_left: 'Modelo não preenchido',
    not_filled: 'Modelo não preenchido',
    duplicate: 'Mesmo arquivo da entrega anterior',
};

const isPending = (verificationInfo) => Boolean(verificationInfo) && verificationInfo.status === PENDING;

const isRejected = (verificationInfo) => Boolean(verificationInfo)
    && (verificationInfo.status === REJECTED || (verificationInfo.status === undefined && verificationInfo.success === false));

const statusLabel = (verificationInfo) => {
    if (isPending(verificationInfo))
        return 'Verificando o arquivo';

    if (!isRejected(verificationInfo))
        return '';

    return REASON_LABELS[verificationInfo.reason] || 'Arquivo Corrompido';
};

const listSuffix = (verificationInfo) => {
    const label = statusLabel(verificationInfo);

    return label ? ` - ${label}` : '';
};

const statusColor = (verificationInfo) => {
    if (!verificationInfo)
        return null;

    if (isPending(verificationInfo))
        return COLORS.pending;

    return isRejected(verificationInfo) ? COLORS.rejected : COLORS.verified;
};

const documentVerification = {
    isPending,
    isRejected,
    statusLabel,
    listSuffix,
    statusColor,
};

export default documentVerification;
